import React from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { ResponsiveImage, Modal } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import ImageCarousel from '../ImageCarousel/ImageCarousel';

import css from './SectionImageGrid.module.css';

const SectionImageGrid = ({
  images,
  rootClassName,
  imageCarouselOpen,
  onImageCarouselClose,
  onManageDisableScrolling,
  handleViewPhotosClick,
  actionBarMaybe,
}) => {
  if (isEmpty(images) || images.length < 5) return null;

  // We only get the first 5 images in the array
  const imagesForGrid = images.reduce((result, image, i) => {
    if (i < 5) {
      result.push(image);
    }
    return result;
  }, []);

  const classes = classNames(rootClassName || css.root);

  const viewPhotosButton = (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage id="ListingPage.viewImagesButton" values={{ count: images.length }} />
    </button>
  );

  return (
    <div className={classes} >
      
      {actionBarMaybe}

      <div className={css.gridContainer} onClick={handleViewPhotosClick}>
        {imagesForGrid.map(image => {
          return (
            <div key={image.id.uuid} className={css.gridItem}>
              <ResponsiveImage
                className={css.gridImage}
                alt={image.id.uuid}
                image={image}
                variants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
              />
            </div>
          );
        })}

      </div>
      {viewPhotosButton}

      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </div>
  );
};

export default SectionImageGrid;
